import * as React from 'react';
import { useGroundingMenuListbox_unstable } from './useGroundingMenuListbox';
import { renderGroundingMenuListbox_unstable } from './renderGroundingMenuListbox';
import { useGroundingMenuListboxStyles_unstable } from './useGroundingMenuListboxStyles.styles';
import type { GroundingMenuListboxProps } from './GroundingMenuListbox.types';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { useInputListboxContextValues } from '@fluentui-copilot/react-input-listbox';

export const GroundingMenuListbox: ForwardRefComponent<GroundingMenuListboxProps> = React.forwardRef((props, ref) => {
  const state = useGroundingMenuListbox_unstable(props, ref);
  const contextValues = useInputListboxContextValues(state);

  useGroundingMenuListboxStyles_unstable(state);
  return renderGroundingMenuListbox_unstable(state, contextValues);
});

GroundingMenuListbox.displayName = 'GroundingMenuListbox';
